"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // レコード区分（見出し）
  REC_HEAD_KBN: 'HEAD',
  // レコード区分（明細）
  REC_DETAIL_KBN: 'DETAIL',
  // アクション区分
  ACTION_KBN: {
    /** 登録 */
    INSERT: '1',
    /** 更新 */
    UPDATE: '2',
    /** 参照 */
    REFER: '3'
  },
  // 変更種別
  UPDATE_KIND: {
    /** 確認結果（はい） */
    RESULT_YES: '1',
    /** 確認結果（いいえ） */
    RESULT_NO: '2',
    /** 成熟度評価 */
    HYOKA: '3'
  },
  /**
   * 監査回答登録ボタン
   */
  ANS_BTN: {
    /** 回答一時保存 */
    ANSWER_TEMP: '0',
    /** 回答登録 */
    ANSWER_STORE: '1',
    /** 被監査部門回答登録 */
    ANSWER_HIKANSA: '2'
  }
});